module.exports = __webpack_public_path__ + "static/media/sketch.6255340a.jpeg";